import script from "./AlzguardExamples.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlzguardExamples.vue?vue&type=script&setup=true&lang=ts"

import "./AlzguardExamples.vue?vue&type=style&index=0&id=fd68b316&lang=css"

const __exports__ = script;

export default __exports__